<template>
  <div class="gift-list">
    <div class="gift-list__items">
      <GiftCard
        v-for="gift in giftsList"
        :key="gift.id"
        :gift="gift"
        :active="current.quantity === gift.quantity"
        :discount="{ amount: gift.old_price, percent: gift.sale }"
        @click="$emit('updateGift', gift)"
      />
    </div>
  </div>
</template>

<script>
import './giftList.scss'

import GiftCard from '@/components/Gift/GiftCard/GiftCard.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'GiftList',
  props: {
    current: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    GiftCard
  },
  data() {
    return {
      giftsList: []
    }
  },
  created() {
    this.getGits()
  },
  computed: {
    ...mapGetters(['language']),
    isRussian() {
      return this.language === 'ru'
    }
  },

  methods: {
    getGits() {
      fetch('https://transfer.backend-pier.com/keys_stock')
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            this.giftsList = data.keys
              .filter(item => item.category === 'robux' && item.platform === 'roblox')
              .sort((a, b) => a.quantity - b.quantity)
          }
        })
        .catch(err => console.log(err))
    }
  }
}
</script>
